module.exports = __webpack_public_path__ + "static/media/A18040103_10004_2.f1ef757d.jpg";